module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/maestro-229195a535e4d266084ef7727662036a.png";